<span *ngIf="(convertedCurrency$ | async) as convertedCurrency">{{(convertedCurrency.amountMicros / 1000000) | currency:convertedCurrency.currency:'symbol-narrow' : '1.0-0'}}</span>

